import { DEFAULT_PRODUCT } from '_utils/constant'
import React from 'react'
import { useFieldArray } from 'react-hook-form'
// import ProductItemIndividual from '../../../pages/Event/components/ProductItemIndividual'
import DesktopProductItem from './DesktopProductItem'
import DesktopProductItemIndividual from './DesktopProductItemIndividual'

const DesktopProductList = ({
  control,
  register,
  setValue,
  errors,
  watch,
  selectedProduct,
}) => {
  const {
    fields,
    append: appendProduct,
    insert: insertProduct,
    remove: removeProduct,
  } = useFieldArray({ control, name: 'products' })

  const watchProducts = watch('products')
  const controlledFields = fields.map((field, i) => ({ ...field, ...watchProducts?.[i] }))

  const swapProduct = (oldIdx, newIdx) => {
    const a = controlledFields[oldIdx]
    const b = controlledFields[newIdx]
    setValue(`products.${oldIdx}`, b)
    setValue(`products.${newIdx}`, a)
    setValue(`products.${oldIdx}.subItems`, b.subItems)
    setValue(`products.${newIdx}.subItems`, a.subItems)
  }

  return (
    <div className='desktop-product-list'>
      {controlledFields.map((item, index) => (
        <React.Fragment key={index}>
          <DesktopProductItem
            key={index}
            productIndex={index}
            product={item}
            totalListProduct={controlledFields.length}
            {...{
              control,
              register,
              insertProduct,
              removeProduct,
              swapProduct,
              watch,
              setValue,
              errors,
            }}
          />
          {item?.splitCasePurchase &&
            typeof item.splitCasePurchase === 'object' &&
            item.splitCasePurchase !== null &&
            item.splitCasePurchase.itemsPerCase && (
              <DesktopProductItemIndividual
                productIndex={index}
                totalListProduct={controlledFields?.length}
                isIndividual={true}
                {...{
                  control,
                  register,
                  appendProduct,
                  insertProduct,
                  removeProduct,
                  swapProduct,
                  watch,
                  setValue,
                  errors,
                }}
                product={item}
              />
            )}
        </React.Fragment>
      ))}
    {!selectedProduct && (
      <div className='desktop-product-list__add'>
        <a onClick={() => appendProduct({ ...DEFAULT_PRODUCT })}>Add Items</a>
      </div>
    )}
    </div>
  )
}

export default DesktopProductList
